fragment BillingAddressFragment on BillingAddress {
    country_name
    firstName
    lastName
    company
    address
    address2
    city
    zip
    country
    state
    phone
    mobile
    email
    vatNumber
}